import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import type {
  IRaangeLabelProps,
} from "../../shared/components/RaangeLabel";
import RaangeLabel from "../../shared/components/RaangeLabel";
import type { IMerchantContext } from "../../merchants/objects/MerchantQueryParam";
import type { IMerchantGroupContext } from "../../merchantgroups/objects/MerchantGroupQueryParam";
import type SmartLink from "../objects/SmartLink";
import { Formatter } from "src/shared/formatters/Formatter";
import FormattedLocalDateTime from "../../shared/formatters/FormattedLocalDateTime";
import { convertInstantStringToLocalDateTime } from "../../utilities/DateUtils";
import BooleanStatusFormatter from "../../shared/formatters/BooleanStatusFormatter";
import { LocalDateTime } from "@js-joda/core";
import styled from "styled-components";

export interface ISmartLinkGeneralLabelProps
  extends Omit<IRaangeLabelProps, "fa"> {}

export interface ISmartLinkLabelProps
  extends ISmartLinkGeneralLabelProps,
    IMerchantContext,
    IMerchantGroupContext {}

export const SmartLinkLabel = ({
  merchant,
  merchantGroup,
  ...rest
}: ISmartLinkLabelProps) => (
  <RaangeLabel fa="list-alt" {...rest}>
    <FormattedMessage id="smartlinks" />
  </RaangeLabel>
);

export const SmartLinkCreate = (props: ISmartLinkGeneralLabelProps) => (
  <RaangeLabel fa="plus" {...props}>
    <FormattedMessage id="smartlinks.create" />
  </RaangeLabel>
);

export const SmartLinkEdit = (props: ISmartLinkGeneralLabelProps) => (
  <RaangeLabel fa="pencil-alt" {...props}>
    <FormattedMessage id="smartlinks.edit" />
  </RaangeLabel>
);

export interface ISmartLinkFormatterProps {
  children: SmartLink;
}

export const SmartLinkExpireAt = ({ children }: ISmartLinkFormatterProps) => {
  const localDateTime = useMemo(
    () =>
      children.expiresAt
        ? convertInstantStringToLocalDateTime(children.expiresAt)
        : undefined,
    [children],
  );

  if (!localDateTime) {
    return <Formatter>{undefined}</Formatter>;
  }

  return (
    <SmartLinkExpireAtStyled
      isExpired={localDateTime.isBefore(LocalDateTime.now())}
    >
      <FormattedLocalDateTime value={localDateTime} />
    </SmartLinkExpireAtStyled>
  );
};

const SmartLinkExpireAtStyled = styled.span<{ isExpired: boolean }>`
  ${({ isExpired }) => (isExpired ? `color: #D0312D` : ``)}
`;

export const SmartLinkStatus = ({ children }: ISmartLinkFormatterProps) => {
  return <BooleanStatusFormatter>{children.status}</BooleanStatusFormatter>;
};
